import Api from '../api'

export default ({

  state: {
  },
  mutations: {
  },
  async loadPurchaseBar({ commit }) {
    let response = await Api.request('get', '/dashboard/reportByPurchaseMonthlyPie/' + this.state.organisationid + '/' + this.state.fyId + '/' + 'purchase')
    if (response.data.status === 'SUCCESS') {
      return response.data.data[0]
    }
  },
  async loadSalesBar({ commit }) {
    let response = await Api.request('get', '/dashboard/reportByPurchaseMonthlyPie/' + this.state.organisationid + '/' + this.state.fyId + '/' + 'sales')
    if (response.data.status === 'SUCCESS') {
      return response.data.data[0]
    }
  },
  async loadWeekSalesBar({ commit }, { month }) {
    let url = `/dashboard/reportBySalesWeeklyPie/${this.state.organisationid}/${this.state.fyId}`
    const params = {}
    if (month) params.monthName = month
    let response = await Api.request('get', url, { params })
    if (response.data.status === 'SUCCESS') {
      return response.data.data[0]
    }
  },
  async loadCashInBar({ commit }) {
    let response = await Api.request('get', '/dashboard/reportByCashInCashOutMonthlyPie/' + this.state.organisationid + '/' + this.state.fyId + '/' + 'in')
    if (response.data.status === 'SUCCESS') {
      return response.data.data[0]
    }
  },
  async loadCashOutBar({ commit }) {
    let response = await Api.request('get', '/dashboard/reportByCashInCashOutMonthlyPie/' + this.state.organisationid + '/' + this.state.fyId + '/' + 'out')
    if (response.data.status === 'SUCCESS') {
      return response.data.data[0]
    }
  },
  async loadPurchaseSalesBar({ commit }) {
    let response = await Api.request('get', '/dashboard/reportByPurchaseMonthlyPie/' + this.state.organisationid + '/' + this.state.fyId + '/' + 'all')
    if (response.data.status === 'SUCCESS') {
      return response.data.data[0]
    }
  },
  // async loadProfitLossMonthly({commit}) {
  //   debugger
  //   let response = await Api.request('get', '/dashboard/reportByProfitAndLossMonthlyPie/' + this.state.organisationid + '/' + this.state.fyId + '/' + 'out')
  //   debugger
  //   if (response.data.status === 'SUCCESS') {
  //     return response.data.data[0]
  //   }
  // },
  getters: {
  }
})



// WEBPACK FOOTER //
// ./src/store/graph.js